import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Button, Popup, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {tasksStatus} from '../../../common/dictionaries/accessories';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import OrdersTable from './table';
import './timeMarked.scss';
import ClosedOrdersModal from './modal/closedOrders';

const typesOptions = [
  {'text': 'Accesorios', 'value': 'accessories'},
  {'text': 'PDS', 'value': 'pds'},
  {'text': 'Control Calidad', 'value': 'qualityAssurance'},
];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'technicianSelected': '',
      'ordersSelected': '',
      'orderTypeSelected': typesOptions[0].value,
      'showTable': false,
      'activeRow': -1,
    };
    this.onGetTaskByOrder = this.onGetTaskByOrder.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.TimeMarked, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchTechnicians();
    this.props.fetchPendingAccessoriesOrders();

    const pendingTasksStatus =
      `${tasksStatus.stopped_for_new_job},${tasksStatus.waiting_for_parts},` +
      `${tasksStatus.waiting_for_approval},${tasksStatus.under_subcontract},${tasksStatus.end_of_day},` +
      `${tasksStatus.detained_for_recess}`;
    this.props.fetchOrderAndTasksStatus({
      'type': 'task',
      'status': pendingTasksStatus,
    });
  }

  getTechniciansOptions() {
    return this.props.techniciansList.map((item) => {
      return {
        'text': `${item.technician} - ${item.name}`,
        'value': item.technician,
      };
    });
  }

  getOrdersOptions() {
    return this.props.pendingOrdersList.map((item) => {
      return {'text': item.order, 'value': item.order};
    });
  }

  changeTechnician(value) {
    this.setState({'showTable': false, 'technicianSelected': value});
  }

  changeOrders(value) {
    this.setState({'showTable': false, 'ordersSelected': value});
  }

  changeType(value) {
    this.setState({'showTable': false, 'orderTypeSelected': value});
  }

  onClearClick() {
    this.setState({
      'technicianSelected': '',
      'ordersSelected': '',
      'orderTypeSelected': typesOptions[0].value,
      'showTable': false,
      'activeRow': -1,
    });
  }

  onSearchClick() {
    const {technicianSelected, ordersSelected, orderTypeSelected} =
      this.state;
    const params = {
      'order': ordersSelected,
      'type': orderTypeSelected,
    };

    this.setState({'showTable': true, 'activeRow': -1});
    this.props.fetchPendingAccessoriesOrders();
    this.props.fetchPendingAccessoriesOrdersByTechnician(
      technicianSelected,
      params
    );
  }

  onGetTaskByOrder(index, order) {
    const {activeRow} = this.state;
    const newIndex = activeRow === index ? -1 : index;
    if (newIndex !== -1) {
      this.props.fetchTasksByOrder(order);
    }
    this.setState({'activeRow': newIndex});
  }

  renderFiltersSection() {
    const {loadingTechnicians, loadingPendingOrders} = this.props;
    const {technicianSelected, ordersSelected, orderTypeSelected} =
      this.state;

    return (
      <div className='filters-section'>
        <Grid textAlign='left'>
          <Grid.Row>
            <Grid.Column width={1}>
              <h4>
                Técnico<span className='required'>*</span>:
              </h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Dropdown
                selection
                options={this.getTechniciansOptions()}
                search
                name='technician-container'
                value={technicianSelected}
                disabled={loadingTechnicians}
                loading={loadingTechnicians}
                onChange={(e, {value}) => this.changeTechnician(value)}
                placeholder='Seleccione Técnico'
                noResultsMessage='Técnico no encontrado'
              />
            </Grid.Column>
            <Grid.Column width={1} textAlign='right'>
              <h4>
                Tipo<span className='required'>*</span>:
              </h4>
            </Grid.Column>
            <Grid.Column width={2}>
              <Dropdown
                selection
                options={typesOptions}
                name='order-type-container'
                value={orderTypeSelected}
                onChange={(e, {value}) => this.changeType(value)}
                placeholder='Tipo'
              />
            </Grid.Column>
            <Grid.Column width={1} textAlign='right'>
              <h4>Orden:</h4>
            </Grid.Column>
            <Grid.Column width={1}>
              <Dropdown
                selection
                options={this.getOrdersOptions()}
                search
                name='orders-container'
                value={ordersSelected}
                disabled={loadingPendingOrders}
                loading={loadingPendingOrders}
                onChange={(e, {value}) => this.changeOrders(value)}
                placeholder='Orden'
                noResultsMessage='Orden no encontrada'
              />
            </Grid.Column>
            <Grid.Column textAlign='right' width={7}>
              <ClosedOrdersModal filters={this.state} />
              <Button
                secondary
                type='submit'
                className='toyota-primary'
                disabled={loadingTechnicians || loadingPendingOrders}
                onClick={this.onClearClick}
              >
                Limpiar
              </Button>
              <Button
                primary
                type='submit'
                className='toyota-primary'
                disabled={
                  loadingTechnicians ||
                  loadingPendingOrders ||
                  !technicianSelected
                }
                onClick={this.onSearchClick}
              >
                Buscar
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  render() {
    return (
      <div className='time-marked-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Marcado de Tiempos</h2>
              <Popup inverted position='bottom left' on='click' flowing
                trigger={<Icon link name='info circle' color='blue' size='large' />}>
                <Popup.Content>
                  <h4><strong>DEFINICIÓN DE COLORES</strong></h4>
                  <div style={{'border': '1px solid white', 'margin-top': '5px', 'padding': '5px'}}>
                    <ul style={{'listStyleType': 'none', 'padding': 0, 'margin': 0}}>
                      <li><Icon name='circle' size='large' style={{'color': '#f8e3cb'}} />
                      Órdenes con tareas iniciadas</li>
                      <li><Icon name='circle' size='large' style={{'color': '#fff8dc'}} />
                      Órdenes con tareas pendientes</li>
                      <li><Icon name='circle' size='large' style={{'color': '#ffff'}} />
                      Órdenes sin trabajar</li>
                    </ul>
                  </div>
                </Popup.Content>
              </Popup>
              <div>
                {this.props.orders?.length > 0 &&
                  <div className='total-box'>
                    Total órdenes: {this.props.orders.length || 0}
                  </div>}
              </div>
            </div>
            {this.renderFiltersSection()}
          </div>
        </Card>
        {this.state.showTable && (
          <OrdersTable
            technicianSelected={this.state.technicianSelected}
            type={this.state.orderTypeSelected}
            taskSelected={this.onGetTaskByOrder}
            activeRow={this.state.activeRow}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingTechnicians': state.techniciansAssignment.loading,
    'techniciansList': state.techniciansAssignment.list,
    'loadingPendingOrders': state.timeMarked.loadingPendingOrders,
    'pendingOrdersList': state.timeMarked.pendingOrdersList,
    'orders': state.timeMarked.orders,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchTechnicians,
  fetchOrderAndTasksStatus,
  fetchPendingAccessoriesOrders,
  fetchPendingAccessoriesOrdersByTechnician,
  fetchTasksByOrder,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchTechnicians,
  fetchOrderAndTasksStatus,
  fetchPendingAccessoriesOrders,
  fetchPendingAccessoriesOrdersByTechnician,
  fetchTasksByOrder,
})(Index);
